export default __webpack_public_path__ + "static/media/unfpa.e280da67.png";